import apiClient from '../middleware/apiClient';
import { SERVICE_RECOVERY } from '../helpers/apis';
import { COTTON_SERVICE_RECOVERY } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';
import { buildInstrument } from '../helpers/payments';
import { REVIEW_PAYMENT, SUBMIT_PAYMENT_SUCCESS } from './payment';

export const GET_SERVICE_RECOVERY = 'GET_SERVICE_RECOVERY';
export const GET_SERVICE_RECOVERY_SUCCESS = 'GET_SERVICE_RECOVERY_SUCCESS';
export const GET_SERVICE_RECOVERY_FAILURE = 'GET_SERVICE_RECOVERY_FAILURE';

export const getServiceRecovery = () => async (dispatch) => {
  const isCottonSession = getCottonSession();

  try {
    const response = await dispatch({
      type: GET_SERVICE_RECOVERY,
      payload: apiClient.fetch(isCottonSession ? COTTON_SERVICE_RECOVERY : SERVICE_RECOVERY),
    }).payload;

    dispatch({
      type: GET_SERVICE_RECOVERY_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: GET_SERVICE_RECOVERY_FAILURE,
      payload: {
        message: error?.data?.message,
        error: error?.status,
      },
    });
  }
};

const dispatchReviewPayment = payload => ({
  type: REVIEW_PAYMENT,
  payload,
});

export const setReviewData = (formData, email) => {
  const { instrument } = buildInstrument(formData);

  return {
    ...formData,
    instrument,
    email,
  };
};

export const reviewPayment = values => async (dispatch, getState) => {
  const {
    user: { user: { preferredEmail, contactEmail } } = {},
  } = getState();

  const reviewData = setReviewData(values, preferredEmail || contactEmail);

  return dispatch(dispatchReviewPayment(reviewData));
};

const dispatchSubmitPaymentSuccess = payload => ({
  type: SUBMIT_PAYMENT_SUCCESS,
  payload,
});

export const setConfirmForApplePay = ({ confirmationNumber, authCode }) => (dispatch, getState) => {
  const { serviceRecovery: { review } = {} } = getState();
  return dispatch(dispatchSubmitPaymentSuccess({
    ...review,
    confirmationNumber: confirmationNumber && `#${confirmationNumber}`,
    authCode: authCode && `#${authCode}`,
  }));
};
